import React, { Component, useEffect, useState } from 'react';
import Db from "../services/OrdersService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import { QRCode } from 'react-qrcode-logo';
import StudentsService from "../services/StudentsService";
import { Modal, ModalBody, Button, Spinner } from "reactstrap";

export default function SelectState(props) {
    //const [purchaseId, setPurchaseId] = useState(11);
    //const [fundraisers, setFundraisers] = useState();
    //const [fundraiserDevice, setFundraiserDevice] = useState();
    const [myFundraiser, setMyFundraiser] = useState();
    //const [qrCode, setQrCode] = useState();
    const { fundraiserDeviceGuid } = useParams();
    const [studentFirstName, setStudentFirstName] = useState("");
    const [studentLastName, setStudentLastName] = useState("");
    const [showButton, setShowButton] = useState(false);
    const [isOptedIn, setIsOptedIn] = useState(null);
    const [showOptInSection, setShowOptInSection] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [isUpdatingOptIn, setIsUpdatingOptIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [shareStatuses, setShareStatuses] = useState([]);

    const navigate = useNavigate();

    // Fetch data on component mount
    useEffect(() => {
        setIsLoading(true);
        Db.getMyFundraiser(fundraiserDeviceGuid)
            .then(x => {
                setMyFundraiser(x);

                if (x.fundraiserDevice.studentFirstName) {
                    setStudentFirstName(x.fundraiserDevice.studentFirstName);
                }
                if (x.fundraiserDevice.studentLastName) {
                    setStudentLastName(x.fundraiserDevice.studentLastName);
                }

                // Set opt-in status
                setIsOptedIn(x.fundraiserDevice.isOptedIn);
                // Always show opt-in section initially unless a decision has already been made
                setShowOptInSection(x.fundraiserDevice.isOptedIn === null);

                // Compute showButton if none of the item options are digital and if the item's id doesnt match cookie dough or beef sticks
                const shouldShowButton = x.fundraiserDevice.fundraiser.fundraiserItems.some(item =>
                    (item.itemId !== 43 && item.itemId !== 44 && item.itemId !== 45 && item.itemId !== 46) &&
                    item.item.itemsOptions.some(option => option.itemOptionTypeId === 0)
                );
                setShowButton(shouldShowButton);
            })
            .finally(() => {
                // Delay for a smoother transition
                setTimeout(() => {
                    setIsLoading(false);
                }, 300);
            });
    }, [fundraiserDeviceGuid]);

    const getMessage = () => {
        let itemText = "";
        if (myFundraiser.fundraiserDevice.fundraiser && myFundraiser.fundraiserDevice.fundraiser.fundraiserItems && myFundraiser.fundraiserDevice.fundraiser.fundraiserItems.length > 0) {
            const items = myFundraiser.fundraiserDevice.fundraiser.fundraiserItems.map(item => item.item.messageTextName || "").filter(Boolean);
            if (items.length > 1) {
                itemText = "purchase " + items.slice(0, -1).join(", ") + " or " + items.slice(-1);
            } else {
                itemText = "purchase " + items[0];
            }
        } else {
            itemText = "donate";
        }

        // Convert C# DateTime to JavaScript Date object and format it
        const endDate = new Date(myFundraiser.fundraiserDevice.fundraiser.endDate);
        const formattedEndDate = endDate.toLocaleDateString("en-US");

        let retValue = "This is " + studentFirstName + " " + studentLastName + " and we are raising money for our " + myFundraiser.fundraiserDevice.fundraiser.team.name + " program at " + myFundraiser.fundraiserDevice.fundraiser.school.name + ".\n";
        retValue += "\nTo support our program, please click on the link below to " + itemText + ". Your generous donation will help me reach my goal of $500 raised. Our fundraiser ends on " + formattedEndDate + ".\n";
        retValue += "\nThank you very much for your support!\n";
        retValue += "- " + studentFirstName + " " + studentLastName;

        return retValue;
    };

    const previewTicket = (ticketGuid) => { window.open('/MyOffers/' + ticketGuid, '_blank') };

    const addShareStatus = (message) => {
        const timestamp = new Date().toLocaleTimeString();
        setShareStatuses(prev => [...prev, { message, timestamp }]);
    };

    const share = (e) => {
        addShareStatus('Share button clicked');
        
        if (navigator.share) {
            addShareStatus('Opening share dialog...');
            console.log('Web Share API is supported');
            
            const shareData = {
                title: 'order',
                text: getMessage(),
                url: 'https://' + window.location.host + '/Order/' + fundraiserDeviceGuid
            };
            
            addShareStatus(`Content prepared - ${shareData.text.length} characters`);

            navigator.share(shareData)
                .then(() => {
                    // More accurate description of what this Promise resolution means
                    addShareStatus('Share sheet displayed successfully');
                    
                    // Increment share clicks
                    Db.incrementShareClicks(fundraiserDeviceGuid)
                        .then(() => {
                            addShareStatus('Share click recorded');
                        })
                        .catch(error => {
                            addShareStatus(`Error recording share: ${error.message}`);
                        });
                })
                .catch((error) => {
                    if (error.name === 'AbortError') {
                        addShareStatus('Share cancelled by user');
                    } else {
                        addShareStatus(`Share error: ${error.message}`);
                    }
                });
        } else {
            addShareStatus('Sharing not supported on this device/browser');
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        myFundraiser.fundraiserDevice.StudentFirstName = studentFirstName;
        myFundraiser.fundraiserDevice.StudentLastName = studentLastName;
        Db.NewOrderWithFDID(myFundraiser.fundraiserDevice).then(x => {
            if (x.data != null) {
                navigate("/order/" + x.data)
            }
        });
    };

    const validateStudentInfo = (e) => {
        e.preventDefault();
        myFundraiser.fundraiserDevice.StudentFirstName = studentFirstName;
        myFundraiser.fundraiserDevice.StudentLastName = studentLastName;
        Db.NewOrderWithFDID(myFundraiser.fundraiserDevice);
    };

    const updateOptInStatus = (status) => {
        if (!myFundraiser || !myFundraiser.fundraiserDevice || !myFundraiser.fundraiserDevice.phone) {
            return;
        }
        
        setIsUpdatingOptIn(true);
        StudentsService.UpdateOptInStatus({
            phone: myFundraiser.fundraiserDevice.phone,
            status: status
        }).then(() => {
            setIsOptedIn(status);
            setShowOptInSection(false);
            setShowConfirmationModal(false);
            setIsUpdatingOptIn(false);
        });
    };

    const handleDeclineClick = () => {
        setShowConfirmationModal(true);
    };

    const renderOptInSection = () => {
        if (!showOptInSection) {
            return null;
        }

        return (
            <div className="my-4" style={{ border: 'none' }}>
                <div className="card-body p-0">
                    <h5 className="card-title text-start">Use Fundraiser Reminders</h5>
                    <div className="mt-3">
                        <Button 
                            color="secondary" 
                            onClick={() => updateOptInStatus(true)} 
                            disabled={isUpdatingOptIn}
                            className="me-2"
                            style={{ borderColor: '#5a6268' }}
                        >
                            Continue
                        </Button>
                        <Button 
                            color="light" 
                            onClick={handleDeclineClick} 
                            disabled={isUpdatingOptIn}
                            style={{ borderColor: '#dee2e6' }}
                        >
                            Disable
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    const renderConfirmationModal = () => {
        return (
            <Modal isOpen={showConfirmationModal} toggle={() => setShowConfirmationModal(false)}>
                <ModalBody>
                    <div className="row d-flex justify-content-center">
                        <h3 className="text-center">Benefits of Fundraiser Reminders</h3>
                        <p>
                            Reminders have been shown to improve fundraiser performance by up to 20%!
                            Your information will never be shared, and your phone number will only be used for these two messages:
                        </p>
                        <ul className="ms-4">
                            <li>One text two days after the fundraiser kickoff</li>
                            <li>One text when there are two days left in the fundraiser</li>
                        </ul>
                        <div className="mt-3 text-center">
                            <Button 
                                color="secondary" 
                                onClick={() => setShowConfirmationModal(false)} 
                                disabled={isUpdatingOptIn}
                                className="me-2"
                                style={{ borderColor: '#5a6268' }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                color="light" 
                                onClick={() => updateOptInStatus(false)} 
                                disabled={isUpdatingOptIn}
                                style={{ borderColor: '#dee2e6' }}
                            >
                                Disable
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    };

    // Helper to determine if content should be shown
    const shouldShowContent = () => {
        // Show content if name is filled AND user has made a decision about reminders
        return studentFirstName && studentLastName && isOptedIn !== null;
    };

    const handleEnableReminders = () => {
        if (!myFundraiser || !myFundraiser.fundraiserDevice || !myFundraiser.fundraiserDevice.phone) {
            return;
        }
        
        setIsUpdatingOptIn(true);
        StudentsService.UpdateOptInStatus({
            phone: myFundraiser.fundraiserDevice.phone,
            status: true
        }).then(() => {
            setIsOptedIn(true);
            setIsUpdatingOptIn(false);
        });
    };

    // Loading spinner
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                <Spinner color="primary" />
                <span className="ms-2">Loading fundraiser...</span>
            </div>
        );
    }

    return (
        <div>
            <h2>{myFundraiser?.fundraiserDevice?.fundraiser?.name}</h2>
            
            <form onSubmit={handleSubmit} className="needs-validation mb-5" noValidate style={{ minHeight: '60vh' }}>
                <div className="row g-3">
                    <div className="col-sm-6">
                        <label htmlFor="firstName" className="form-label">First name</label>
                        <input type="text" className="form-control" id="firstName" placeholder=""
                            value={studentFirstName}
                            onChange={e => (
                                setStudentFirstName(e.target.value)
                            )}
                            onBlur={validateStudentInfo}
                            required />
                        <div className="invalid-feedback">
                            Valid first name is required.
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <label htmlFor="lastName" className="form-label">Last name</label>
                        <input type="text" className="form-control" id="lastName" placeholder="" value={studentLastName}
                            onChange={e => (
                                setStudentLastName(e.target.value)
                            )}
                            onBlur={validateStudentInfo}
                            required />
                        <div className="invalid-feedback">
                            Valid last name is required.
                        </div>
                    </div>
                </div>

                {/* Show opt-in section after name entry if no decision made yet */}
                {isOptedIn === null && (
                    <div className="mt-4">
                        {renderOptInSection()}
                    </div>
                )}

                {/* Show reminder status and option to re-enable if currently off */}
                {isOptedIn === false && studentFirstName && studentLastName && (
                    <div className="mt-4">
                        <div className="reminder-status-container" style={{ border: '1px solid #ccc', padding: '10px', marginTop: '20px', marginBottom: '20px', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span>
                                Fundraiser Reminders: Off
                            </span>
                            <button
                                className="btn btn-outline-primary"
                                type="button"
                                onClick={handleEnableReminders}
                                disabled={isUpdatingOptIn}
                            >
                                Enable Reminders
                            </button>
                        </div>
                    </div>
                )}

                {/* Only show rest of content after opt-in decision is made */}
                <div id="orderOptions" style={{ display: shouldShowContent() ? 'block' : 'none' }}>
                    <div className="d-flex" style={{ paddingTop: 24 }}>
                        <a href={"/FundraiserOrders/" + myFundraiser?.fundraiserDevice?.guid} className="btn btn-primary btn-lg btn-block" type="button">
                            Orders: {myFundraiser?.ordersQty} - Total: ${myFundraiser?.ordersTotal}
                        </a>
                    </div>
                    {showButton &&
                        <div className="d-flex" style={{ paddingTop: 24 }}>
                            <button className="btn btn-primary btn-lg btn-block" type="submit">
                                New Order (Cash / Check)?
                            </button>
                        </div>
                    }
                    {myFundraiser && myFundraiser.fundraiserDevice && myFundraiser.fundraiserDevice.fundraiser.ticket && myFundraiser.fundraiserDevice.fundraiser.ticket.guid ?
                        <div className="d-flex" style={{ paddingTop: 24 }}>
                            <button className="btn btn-primary btn-lg btn-block" type="button" onClick={() => previewTicket(myFundraiser.fundraiserDevice.fundraiser.ticket.guid)}>
                                Digital Ticket Preview
                            </button>
                        </div> : <></>}

                    <div className="d-flex" style={{ paddingTop: 24 }}>
                        <button className="btn btn-primary btn-lg btn-block" type="button" onClick={share}>
                            Share
                        </button>
                    </div>
                    <div className="d-flex justify-content-center" style={{ padding: 24 }} >
                        <QRCode
                            value={"https://" + window.location.host + "/Order/" + fundraiserDeviceGuid}
                            eyeRadius={5}
                            qrStyle="dots"
                            size={window.innerWidth < 300 ? window.innerWidth - 40 : 300}
                        />
                    </div>
                </div>
            </form>
            
            {/* Confirmation modal for declining reminders */}
            {renderConfirmationModal()}
        </div>
    );
}
